import { render, staticRenderFns } from "./PlayButtonHeader.vue?vue&type=template&id=ec3c9874&scoped=true&"
import script from "./PlayButtonHeader.vue?vue&type=script&lang=js&"
export * from "./PlayButtonHeader.vue?vue&type=script&lang=js&"
import style0 from "./PlayButtonHeader.vue?vue&type=style&index=0&id=ec3c9874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3c9874",
  null
  
)

export default component.exports